import { useSelector } from "react-redux";
import CountUp from "./01_util/counter";
import {
  StatisticsWrapper,
  BlockWrapper,
  Numbers,
  Words,
} from "./StatisticsStyle"; // <-- your file from the snippet
import { about } from "../../../i18n/03_about";

const DURATION_MS = 1600; // same finish time for all


export default function StatisticsSection() {
  const lang = useSelector(state => state.lang.lang)
  const t = about[lang]

  return (
    <StatisticsWrapper>
      {t.statsItems.map((val, ind) => (
        <BlockWrapper key={ind}>
          <Numbers>
            <CountUp to={val.value} duration={DURATION_MS} />
          </Numbers>
          <Words>{val.label}</Words>
        </BlockWrapper>
      ))}
    </StatisticsWrapper>
  );
}
